import ResultsAward from './resultsAward.js';
export default ResultsAward;
